import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { projectTagsLoad } from 'portal/store/events/actions'
import { useModuleIds } from './useModuleIds'

type ProjectTagsState = {
  loading: boolean
  loaded: boolean
  error: unknown
  items: string[]
}

const EMPTY_PROJECT_TAGS_STATE: ProjectTagsState = {
  loading: false,
  loaded: false,
  error: null,
  items: []
}

export function useProjectTags() {
  const dispatch = useDispatch()
  const { accountId, projectId } = useModuleIds()

  const projectKey = useMemo(
    () => `${accountId}_${projectId}`,
    [accountId, projectId]
  )

  const projectTagsState: ProjectTagsState = useSelector((state: any) =>
    state.events?.projectTags?.[projectKey]
      ? state.events.projectTags[projectKey]
      : EMPTY_PROJECT_TAGS_STATE
  )

  useEffect(() => {
    if (!accountId || !projectId) {
      return
    }

    if (!projectTagsState.loaded && !projectTagsState.loading) {
      dispatch(projectTagsLoad(accountId, projectId))
    }
  }, [
    accountId,
    dispatch,
    projectId,
    projectTagsState.loaded,
    projectTagsState.loading
  ])

  return {
    projectTags: projectTagsState.items || [],
    loading: projectTagsState.loading,
    loaded: projectTagsState.loaded,
    error: projectTagsState.error,
    reload: () => {
      if (!accountId || !projectId) {
        return
      }

      dispatch(projectTagsLoad(accountId, projectId))
    }
  }
}
